import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { CustomCountrySelect } from "./CustomCountrySelect"

export function TrialFormFields({ formData, errors, onFieldChange }) {
  return (
    <div className="space-y-1">
      <div>
        <Label htmlFor="firstName" className="text-[16px] text-[#161616] font-bold">
          First name
        </Label>
        <Input
          id="firstName"
          value={formData.firstName}
          onChange={(e) => onFieldChange("firstName", e.target.value)}
          className="h-[36px] border-[#6E6E70]"
        />
        {errors.firstName && <p className="text-sm text-[#ED2D00]">{errors.firstName}</p>}
      </div>

      <div>
        <Label htmlFor="lastName" className="text-[16px] text-[#161616] font-bold">
          Last name
        </Label>
        <Input
          id="lastName"
          value={formData.lastName}
          onChange={(e) => onFieldChange("lastName", e.target.value)}
          className="h-[36px] border-[#6E6E70]"
        />
        {errors.lastName && <p className="text-sm text-[#ED2D00]">{errors.lastName}</p>}
      </div>

      <div>
        <Label htmlFor="email" className="text-[16px] text-[#161616] font-bold">
          Business email
        </Label>
        <Input
          id="email"
          value={formData.email}
          onChange={(e) => onFieldChange("email", e.target.value)}
          className="h-[36px] border-[#6E6E70]"
        />
        {errors.email && <p className="text-sm text-[#ED2D00]">{errors.email}</p>}
      </div>

      <div>
        <Label htmlFor="company" className="text-[16px] text-[#161616] font-bold">
          Company
        </Label>
        <Input id="company" value={formData.company}
        onChange={(e) => onFieldChange("company", e.target.value)}
        className="h-[36px] border-[#6E6E70]" />
        {errors.company && <p className="text-sm text-[#ED2D00]">{errors.company}</p>}
      </div>

      <div>
        <Label htmlFor="country" className="text-[16px] text-[#161616] font-bold">
          Country or region
        </Label>
        <CustomCountrySelect
          className="border border-[#6e6e70] rounded-[0px]"
          value={formData.country}
          onChange={(value) => onFieldChange("country", value)}
          error={errors.country}
        />
        {errors.country && <p className="text-sm text-[#ED2D00]">Country is Required</p>}
      </div>

      <div>
        <Label htmlFor="password" className="text-[16px] text-[#161616] font-bold">
          Password
        </Label>
        <Input
          id="password"
          type="password"
          value={formData.password}
          onChange={(e) => onFieldChange("password", e.target.value)}
          className="h-[36px] border-[#6E6E70] placeholder:text-[rgba(77,77,77,0.40)]"
          placeholder="8-20 chars, with uppercase, lowercase & special chars"
        />
        {errors.password && <p className="text-sm text-[#ED2D00]">{errors.password}</p>}
      </div>

      <div>
        <Label htmlFor="confirmPassword" className="text-[16px] text-[#161616] font-bold">
          Confirm Password
        </Label>
        <Input
          id="confirmPassword"
          type="password"
          value={formData.confirmPassword}
          onChange={(e) => onFieldChange("confirmPassword", e.target.value)}
          className="h-[36px] border-[#6E6E70] placeholder:text-[rgba(77,77,77,0.40)]"
          placeholder="Re-enter your password"
        />
        {errors.confirmPassword && <p className="text-sm text-[#ED2D00]">{errors.confirmPassword}</p>}
      </div>
    </div>
  )
}
